import type { UIMatch } from "react-router";

import type { AppHandle } from "./handle.types";

/**
 * SFCC-11845: true when any matched route hides the shared header mini-cart
 * entirely via `handle.hideMinicart` (e.g. the cart page, where the mini-cart
 * duplicates the full cart view).
 *
 * Mirrors SFRA, which omits the whole minicart `<div>` (icon + count) from the
 * DOM on the cart page via `<isif condition="${pdict.action !== 'Cart-Show'}">`
 * in `org_hec/.../components/header/pageHeader.isml` — it is not CSS-hidden.
 *
 * Declarative per-route flag read off `useMatches()` — no route/path coupling
 * in the component. Mirrors the existing `handle`-based conventions
 * (`app/seo/seo.tsx`, meganav variant).
 */
export const isMinicartHidden = (
  matches: ReadonlyArray<Pick<UIMatch, "handle">>,
): boolean =>
  matches.some(m => (m.handle as AppHandle | undefined)?.hideMinicart === true);

/**
 * See `AppHandle.suppressAddedToBasketModal`. Loader data can set the same flag
 * (the catch-all's Builder-mounted spender page, COM-474).
 */
export const isAddedToBasketModalSuppressed = (
  matches: ReadonlyArray<Pick<UIMatch, "handle"> & { data?: unknown }>,
): boolean =>
  matches.some(({ handle, data }) =>
    [handle, data].some(
      flags =>
        (flags as AppHandle | undefined)?.suppressAddedToBasketModal === true,
    ),
  );
